import { z } from 'zod';
export const refreshUserScorePathSchema = z.object({
    subdomain: z.string(),
    tradingCompetitionId: z.string(),
});
export const refreshUserScoreQuerySchema = z.object({
// No query parameters needed for now
});
export const refreshUserScoreOutputSchema = z.object({
    success: z.boolean(),
    processedTransactions: z.number(),
    volumeAdded: z.number(),
    rateLimited: z.boolean(),
});
